import axios from "./axios";
import { userData } from "./Currentuserdata";

export default {
    /**
     * Get All providers
     * @api {Get} manageprovider
     */
    getProviders(data) {
        const options = {
            method: 'GET',
            url: 'manageprovider/provider-list',
            headers: {'content-type': 'application/json'},
            params: data
        };
        return new Promise((resolve, reject) => {
            axios(options)
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error.message)
                })
        })
    },
    getAllpaymentsByInvoice(data) {
        const options = {
            method: 'GET',
            url: 'manageprovider/providerpayment',
            headers: {'content-type': 'application/json'},
            params: data
        };
        return new Promise((resolve, reject) => {
            axios(options)
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error.message)
                })
        })
    },
    getFilterpaymentsByInvoice(data) {
        const options = {
            method: 'GET',
            url: 'manageprovider/providerpayment/filtered',
            headers: {'content-type': 'application/json'},
            params: data
        };
        return new Promise((resolve, reject) => {
            axios(options)
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error.message)
                })
        })
    },

    getProvidersHistory(data) {
        const options = {
            method: 'GET',
            url: 'manageprovider/provider/manage/history',
            headers: {'content-type': 'application/json'},
            params: data
        };
        return new Promise((resolve, reject) => {
            axios(options)
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error.message)
                })
        })
    },

    filterProviders(data) {
        const options = {
            method: 'GET',
            url: 'manageprovider/provider/manage/filtered',
            headers: {'content-type': 'application/json'},
            params: data
        };
        return new Promise((resolve, reject) => {
            axios(options)
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error.message)
                })
        })
    },

    getCheckedProvidersOfProduct(data) {
        const options = {
            method: 'GET',
            url: 'manageprovider/getCheckedProvidersOfProduct',
            headers: {'content-type': 'application/json'},
            params: data
        };
        return new Promise((resolve, reject) => {
            axios(options)
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error.message)
                })
        })
    },

    /**
     * Add provider
     * @api {POST} manageprovider
     */
    addProvider(data) {
        
        const options = {
            method: 'POST',
            url: 'manageprovider',
            headers: {'content-type': 'application/json'},
            data: data
        };
        return new Promise((resolve, reject) => {
            axios(options)
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error.message)
                })
        })
    },


    /**
     * Update provider
     * @api {PUT} manageprovider
     */
    updateProvider(id, data) {
        const options = {
            method: 'PUT',
            url: `manageprovider/${id}`,
            headers: {'content-type': 'application/json'},
            data: data
        };
        return new Promise((resolve, reject) => {
            axios(options)
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error.message)
                })
        })
    },

    logicalDeleteProvider(id) {
        const options = {
            method: "PUT",
            url: `manageprovider/logicaldelete/${id}`,
            headers: { "content-type": "application/json" },
        };
        return new Promise((resolve, reject) => {
            axios(options)
                .then((response) => {
                    resolve(response.data);
                })
                .catch((error) => {
                    reject(error.message)
                });
        });
    },

    /**
     * Delete provider
     * @api {DELETE} manageprovider/:id
     */
    deleteProvider(id) {
        const user = userData();
        const options = {
            method: 'DELETE',
            url: `manageprovider/${id}`,
            headers: {'content-type': 'application/json'},
            data: {
                ID_Branch: user.branch,
                ID_Business: user.businessid
            }
        };
        return new Promise((resolve, reject) => {
            axios(options)
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error.message)
                })
        })
    },

    getAcountsPayable(data) {
        const options = {
            method: 'POST',
            url: `manageprovider/getAcountsPayable`,
            headers: {'content-type': 'application/json'},
            data: data
        };
        return new Promise((resolve, reject) => {
            axios(options)
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error.message)
                })
        })
    },
    getAllPaymentsByPurchase(data) {
        const options = {
          method: "POST",
          url: "manageprovider/getAllPaymentsByPurchase",
          headers: { "content-type": "application/json" },
          data: data,
        };
        return new Promise((resolve, reject) => {
          axios(options)
            .then((response) => {
              resolve(response.data);
            })
            .catch((error) => {
              reject(error.message)
            });
        });
    },
    getFilterPaymentsByPurchase(data) {
        const options = {
          method: "POST",
          url: "manageprovider/getFilterPaymentsByPurchase",
          headers: { "content-type": "application/json" },
          data: data,
        };
        return new Promise((resolve, reject) => {
          axios(options)
            .then((response) => {
              resolve(response.data);
            })
            .catch((error) => {
              reject(error.message)
            });
        });
    },
    getPurchasePendingToPay(data) {
        const options = {
          method: "POST",
          url: "manageprovider/getPurchasePendingToPay",
          headers: { "content-type": "application/json" },
          data: data,
        };
        return new Promise((resolve, reject) => {
          axios(options)
            .then((response) => {
              resolve(response.data);
            })
            .catch((error) => {
              reject(error.message)
            });
        });
    },
    getPurchaseWithCredit(data) {
        const options = {
          method: "POST",
          url: "manageprovider/getPurchaseWithCredit",
          headers: { "content-type": "application/json" },
          data: data,
        };
        return new Promise((resolve, reject) => {
          axios(options)
            .then((response) => {
              resolve(response.data);
            })
            .catch((error) => {
              reject(error.message)
            });
        });
    },
    getFilterPurchaseWithCredit(data) {
        const options = {
          method: "POST",
          url: "manageprovider/getFilterPurchaseWithCredit",
          headers: { "content-type": "application/json" },
          data: data,
        };
        return new Promise((resolve, reject) => {
          axios(options)
            .then((response) => {
              resolve(response.data);
            })
            .catch((error) => {
              reject(error.message)
            });
        });
    },
    addPaymentToAccountPayable(data){
        const options = {
          method: "POST",
          url: "manageprovider/addPaymentToAccountPayable",
          headers: { "content-type": "application/json" },
          data: data
        };
        return new Promise((resolve, reject) => {
          axios(options)
            .then((response) => {
              resolve(response.data);
            })
            .catch((error) => {
              reject(error.message);
            });
        });
    },
    importProviders(data){
        const options = {
          method: "POST",
          url: "manageprovider/importProviders",
          headers: { "content-type": "application/json" },
          data: data
        };
        return new Promise((resolve, reject) => {
          axios(options)
            .then((response) => {
              resolve(response.data);
            })
            .catch((error) => {
              reject(error.message);
            });
        });
    },

    // Importar Proveedores V2: rechaza con el cuerpo del backend ({ message, errors: [{ path, message }] }) para pintar las celdas.
    importProvidersV2(data) {
        const options = {
            method: 'POST',
            url: 'manageprovider/providers/v2/import',
            headers: { 'content-type': 'application/json' },
            data: data,
            noAutomaticRetry: true
        };
        return new Promise((resolve, reject) => {
            axios(options)
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    // Solo un cuerpo JSON trae { message, errors }; un 502/504 del proxy trae una página HTML que no se muestra tal cual.
                    const data = error.response?.data;
                    const message = error.response ? `El servidor respondió con error ${error.response.status}. Intente de nuevo.` : error.message;
                    reject(data && typeof data === "object" ? data : { message, errors: [] })
                })
        });
    },

    getProvidersAllWithAccounts(data) {
        const options = {
            method: 'GET',
            url: 'manageprovider/provider/manage/allWithAccounts',
            headers: {'content-type': 'application/json'},
            params: data
        };
        return new Promise((resolve, reject) => {
            axios(options)
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error.message)
                })
        })
    },
    getProvidersFilteredWithAccounts(data) {
        const options = {
            method: 'GET',
            url: 'manageprovider/provider/manage/filteredWithAccounts',
            headers: {'content-type': 'application/json'},
            params: data
        };
        return new Promise((resolve, reject) => {
            axios(options)
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error.message)
                })
        })
    },
    getProvidersFilteredColumnWithAccounts(data) {
        const options = {
            method: 'POST',
            url: 'manageprovider/provider/manage/filteredColumnWithAccounts',
            headers: {'content-type': 'application/json'},
            data
        };
        return new Promise((resolve, reject) => {
            axios(options)
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error.message)
                })
        })
    },
    getSpecifiedProvider(id, params = {}) {    
        const options = {
            method: "GET",
            url: `manageprovider/${id}`,
            headers: {'content-type': 'application/json'},
            params
        };
        return new Promise((resolve, reject) => {
        axios(options)
            .then((response) => {
            resolve(response.data);
            })
            .catch((error) => {
            reject(error.message)
            });
        });
    },
    deleteReceipt(data) {
        const options = {
          method: "POST",
          url: "manageprovider/deleteReceipt",
          headers: { "content-type": "application/json" },
          data: data
        };
        return new Promise((resolve, reject) => {
          axios(options)
            .then((response) => {
              resolve(response.data);
            })
            .catch((error) => {
              reject(error.message);
            });
        });
    },

    async getLastPurchasesByProvider(params_) {
        const { ID_Provider, ...params } = params_
        const options = {
            method: "GET",
            url: `manageprovider/provider/${ID_Provider}/purchase-orders`,
            params,
            headers: { "content-type": "application/json" },
        };
        return axios(options)
    },

    getProviderAccountStatement(data){
        const options = {
            method: "GET",
            url: "manageprovider/getProviderAccountStatement",
            headers: { "content-type": "application/json" },
            params: data
        };
        return new Promise((resolve, reject) => {
        axios(options)
            .then((response) => {
                console.log('response', response);
                resolve(response.data);
            })
            .catch((error) => {
                reject(error.message);
            });
        });
    },
}
